import { useSelector } from "react-redux";
import { selectors } from "store";
import paymentSelectors from "store/selectors/payments";

export interface PaymentInfoBannerPropsHook {
  title?: string;
  isLoading?: boolean;
}

export default function usePaymentInfoBannerProps(): PaymentInfoBannerPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const payment = useSelector(paymentSelectors.getFormattedPayment);

  const title = payment?.id;

  return {
    title,
    isLoading,
  };
}
